import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var FilterListIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M2 10.5C2 9.67157 2.67157 9 3.5 9H44.5C45.3284 9 46 9.67157 46 10.5C46 11.3284 45.3284 12 44.5 12H3.5C2.67157 12 2 11.3284 2 10.5ZM18 37.5C18 36.6716 18.6716 36 19.5 36H28.5C29.3284 36 30 36.6716 30 37.5C30 38.3284 29.3284 39 28.5 39H19.5C18.6716 39 18 38.3284 18 37.5ZM10.5 22C9.67157 22 9 22.6716 9 23.5C9 24.3284 9.67157 25 10.5 25H37.5C38.3284 25 39 24.3284 39 23.5C39 22.6716 38.3284 22 37.5 22H10.5Z"
  }));
});
FilterListIcon.displayName = 'FilterListIcon';
FilterListIcon.defaultProps = {
  'aria-label': 'Filter List'
};
export default FilterListIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/FilterListIcon/index.js
// module id = 1845
// module chunks = 12